import styled from 'styled-components';

export const Wrapper = styled.div`
  display: block;
  padding: 1.25rem;
  border-radius: 6px;
`;
